import { render } from "./NavsTabs.vue?vue&type=template&id=71c95a2d"
import script from "./NavsTabs.vue?vue&type=script&lang=js"
export * from "./NavsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__